import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getCellsUsedBands } from '@api/cells';

import { TBandDTO } from '@interfaces/cells/dto/cellsDTO';

import { CELLS_USED_BANDS } from '@constants/queryKeys';

interface IUseQueryCellsUsedBands {
	cellsUsedBands: Array<TBandDTO>;
	isLoading: boolean;
}

export const useQueryCellsUsedBands = (): IUseQueryCellsUsedBands => {
	const {
		accessPermission: {
			networkOperatorTelecomSitesAttributeUpdater,
			networkOperatorTelecomSitesViewer,
			networkOperatorKpiViewer,
			networkOperatorKpiUpdater,
		},
	} = useAppSelector(auth);

	const isSectorsAvailable = (
		networkOperatorTelecomSitesAttributeUpdater ||
		networkOperatorTelecomSitesViewer ||
		networkOperatorKpiViewer ||
		networkOperatorKpiUpdater
	);

	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [CELLS_USED_BANDS],
		queryFn: getCellsUsedBands,
		enabled: [isSectorsAvailable],
	});

	return {
		cellsUsedBands: data || [],
		isLoading: isInitialLoading,
	};
};
